<template>
    <a v-if="shouldShow()" :href="href()"><slot></slot></a>
</template>

<script setup lang="ts">
    import type {KeyTextField, LinkField} from '@prismicio/types';
    import {useLinkHelper, usePrismicFieldHelpers, usePrismicTypeGuards} from '#imports';

    const {isLink} = usePrismicFieldHelpers();
    const {isFilledKeyText} = usePrismicTypeGuards();
    const {getLink} = useLinkHelper();

    const props = defineProps<{
        field: LinkField | KeyTextField;
    }>();

    function shouldShow(): boolean {
        return isFilledKeyText(props.field) || isLink('_', props.field);
    }

    function href(): string {
        return getLink(props.field)?.url ?? '';
    }
</script>
